import $ from "jquery";

$(() => {
    const scrollContainer = document.getElementById('scroll-container');
    const scroll = document.querySelector('#scroll-container .grid');
    if (scrollContainer != null) {
        scroll.addEventListener('scroll', () => {
            const atBottom = scroll.scrollHeight - scroll.scrollTop <= scroll.clientHeight + 1;

            if (atBottom) {
                scrollContainer.classList.add('at-bottom');
            } else {
                scrollContainer.classList.remove('at-bottom');
            }
        });
         const atBottom = scroll.scrollHeight - scroll.scrollTop <= scroll.clientHeight + 1;

            if (atBottom) {
                scrollContainer.classList.add('at-bottom');
            } else {
                scrollContainer.classList.remove('at-bottom');
            }
    }

});

